export enum ESolarServiceProvider {
  GOODWE = "GOODWE",
  DEYE = "DEYE",
  VRM = "VRM",
  GROWATT = "GROWATT",
  POWERHUB = "POWERHUB",
  SCOUT = "SCOUT",
  ECOFLOW = "ECOFLOW",
}
